// pdfjs parses PDFs in a module worker, a separate realm that the page-level
// promiseWithResolversPolyfill never reaches. On Chrome < 119 and
// Safari < 17.4 the stock worker threw "Promise.withResolvers is not a
// function" (Sentry DIRECTDENTAL-2AD, GitHub #1502). This wraps the worker in
// a same-origin blob module that installs the polyfill first, then imports the
// real worker. pdfjs already wraps cross-origin worker URLs in a blob the same
// way, so this adds no new loading path.
export const WORKER_POLYFILL =
  'if (typeof Promise.withResolvers !== "function") {' +
  "  Promise.withResolvers = function () {" +
  "    var resolve, reject;" +
  "    var promise = new Promise(function (res, rej) { resolve = res; reject = rej; });" +
  "    return { promise: promise, resolve: resolve, reject: reject };" +
  "  };" +
  "}";

// The import stays dynamic so it runs after the polyfill (static imports and
// `export ... from` are evaluated first). The re-export matters when the
// worker fails to start: pdfjs then imports workerSrc on the main thread and
// reads its WorkerMessageHandler export for the "fake worker" fallback.
export function buildPdfWorkerSource(workerUrl: string): string {
  return (
    `${WORKER_POLYFILL}\n` +
    `const pdfjsWorker = await import(${JSON.stringify(workerUrl)});\n` +
    "export const WorkerMessageHandler = pdfjsWorker.WorkerMessageHandler;\n"
  );
}

// workerUrl must be absolute: a blob module resolves relative imports against
// the blob URL, not the page.
export function pdfWorkerSrc(workerUrl: string): string {
  if (typeof Blob === "undefined" || typeof URL.createObjectURL !== "function") {
    return workerUrl;
  }
  const blob = new Blob([buildPdfWorkerSource(workerUrl)], { type: "text/javascript" });
  return URL.createObjectURL(blob);
}
